export const toolStateMap = new WeakMap();
